import React from 'react'
import { Box } from '@material-ui/core'
import { RuleStepProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FreeDeliveryRuleState } from './types'
import {
	NumSpinner,
	ParamRow,
	RuleParamsPanel,
} from '../../CampaignModalSkeleton/components'

export function FreeDeliveryRuleStep({
	rule,
	setRule,
	description,
}: RuleStepProps<FreeDeliveryRuleState>) {
	const thresholdError = rule.threshold !== null && rule.threshold <= 0

	return (
		<Box>
			{description}
			<RuleParamsPanel>
				<ParamRow
					label="Panier minimum"
					description="Montant minimum pour offrir les frais de livraison"
					error={thresholdError}
					isLast
				>
					<NumSpinner
						value={rule.threshold}
						onChange={(v) => setRule((prev) => ({ ...prev, threshold: v }))}
						min={1}
						max={999999}
						suffix="€"
						placeholder="20"
						step="any"
					/>
				</ParamRow>
			</RuleParamsPanel>
		</Box>
	)
}
